var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("chip my-" + _vm.myIndicator + " " + (_vm.simple ? 'no-range' : ''))},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }